/* Dekorowo: open the cart drawer 500ms after add-to-cart intent. */
(() => {
  if (window.__dekorowoInstantCartOpen) return;
  window.__dekorowoInstantCartOpen = true;
  document.documentElement.dataset.instantCartReady = 'true';

  let pendingOpen = null;

  const scheduleOpen = (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const addButton = target && target.closest('button[name="add"]');
    if (!addButton || addButton.disabled || pendingOpen) return;

    const scheduledAt = performance.now();

    pendingOpen = window.setTimeout(() => {
      pendingOpen = null;

      const drawer = document.getElementById('CartDrawer');
      if (!drawer || !drawer.hasAttribute('hidden')) return;

      if (typeof drawer.show === 'function') {
        drawer.show(addButton, true);
      } else {
        const trigger = Array.from(document.querySelectorAll('a[aria-controls="CartDrawer"]'))
          .find((element) => element.offsetParent !== null);
        if (trigger) trigger.click();
      }

      window.__dekorowoInstantCartLatency = performance.now() - scheduledAt;
      document.documentElement.dataset.instantCartLatency = window.__dekorowoInstantCartLatency.toFixed(2);
    }, 500);
  };

  document.addEventListener('pointerdown', scheduleOpen, true);
  document.addEventListener('click', scheduleOpen, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') scheduleOpen(event);
  }, true);
})();
